import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'sortByAlpha'
})
export class SortByAlphaPipe implements PipeTransform {
	public transform(value: Array<any>, ...opts): any {
		if (!value || !value.length) { return value; }

		const key: string = opts[0] || 'title',
			order: number = opts[1] || 1; // 1 ==> Ascending order

		return value.sort((a, b) => {
			// val === null ? blankString : convertValueIntoString so that trim works
			// Converting null into blank string so that we do not need handle both null and blank string
			const _a = a[key] === null ? '' : '' + a[key],
				_b = b[key] === null ? '' : '' + b[key];

			if (_a.trim() === '') { return 1; }
			else if (_b.trim() === '') { return -1; }
			else { return _a.localeCompare(_b) * order; }
		});
	}
}
